import { render, staticRenderFns } from "./smart-sticker.vue?vue&type=template&id=dd79d750&scoped=true"
import script from "./smart-sticker.vue?vue&type=script&lang=js"
export * from "./smart-sticker.vue?vue&type=script&lang=js"
import style0 from "./smart-sticker.vue?vue&type=style&index=0&id=dd79d750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd79d750",
  null
  
)

export default component.exports